import { createContext } from "react"

const BuildingsManagementContext = createContext();

export default BuildingsManagementContext;